import { Component, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { ToastMessageOptions } from 'primeng/api';

import { LayoutTypesEnum } from '../../../../Common/Layout/enums/layout-types.enum';
import { MonitoringLeftSidebarService } from '../../../../Monitor/Core/services/monitoring-left-sidebar.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { AmplifyDialogComponentTextModel } from '../../../../Common/Dialogs/models/amplify-dialog-component-text.model';
import { DialogActionButtonModel } from '../../../../Common/Dialogs/models/dialog-action-button.model';
import { ReportListItemModel } from '../../../../Common/Reports/models/report-list-item.model';
import { AbstractHypeService } from '../../../../Common/Layout/services/abstract-hype.service';
import { LeftSidebarService } from '../../../../Common/Layout/services/left-sidebar.service';
import { ReportsHypeService } from '../../services/reports-hype.service';
import { ReportsLeftSidebarService } from '../../services/reports-left-sidebar.service';
import { LeftSidebarManagementService } from '../../../../Common/Layout/services/left-sidebar-management.service';
import { ReportsLeftSidebarManagementService } from '../../services/reports-left-sidebar-management.service';

export interface MonitoringAmplifyProperties {
    dataSource: any[];
    fullData: any[];
    dropdownDataSource: string[];
    width: number;
    localization: AmplifyDialogComponentTextModel;
    icon: string;
    filterPlaceholder: string;
    createNew: Function;
    useSelected: Function;
    cancel: Function;
    close: Function;
    search: Function;
    userOptions?: DialogActionButtonModel[];
}

@Component({
    selector: 'agpr-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    providers: [
        {
            provide: LeftSidebarService,
            useExisting: ReportsLeftSidebarService
        },
        {
            provide: AbstractHypeService,
            useClass: ReportsHypeService
        },
        {
            provide: LeftSidebarManagementService,
            useClass: ReportsLeftSidebarManagementService
        }
    ],
    standalone: false
})
export class ReportsComponent implements OnDestroy {

    readonly layout = LayoutTypesEnum.horizontal;
    readonly id: string = 'Reports';

    public showQuickReportDialog: boolean = false;

    public messages: ToastMessageOptions[];
    public reportList: ReportListItemModel[] = [];

    private localizationsLoaded: boolean = false;

    public amplify: MonitoringAmplifyProperties;
    public amplifyVisible: boolean = false;

    public amplifyReport: MonitoringAmplifyProperties;
    public amplifyReportsButtons: DialogActionButtonModel[] = [];

    private subscriptions: Subscription[] = [];

    constructor(
        public sidebarService: MonitoringLeftSidebarService,
        private localizationService: LocalizationService
    ) {
        this.subscriptions.push(
            this.localizationService.getLocalizationMapChange().subscribe(
                () => {
                    this.localizationsLoaded = true;
                }
            )
        );
    }

    /**
     * Opens the specified amplify dialog
     */
    private openAmplify(dialogProperties: MonitoringAmplifyProperties): void {
        this.amplify = dialogProperties;
        this.amplifyVisible = true;
    }

    /**
     * Closes the amplify dialog
     */
    private closeAmplify(): void {
        this.amplifyVisible = false;
        this.amplify = null;
    }

    /**
     * Sorts an list by modified date (or created date, if modified date is not available)
     */
    private sortByDate(a, b): number {
        return (+b.modifiedDate || +b.createdDate) - (+a.modifiedDate || +a.createdDate);
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
